import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const DownloadToken = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [tokenData, setTokenData] = useState(null);

  useEffect(() => {
    // Load token data from Firestore
    setLoading(false);
  }, [id]);

  if (loading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (
    <div style={{ minHeight: '100vh', padding: '2rem', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ background: 'white', padding: '2rem', borderRadius: '20px', maxWidth: '600px', margin: '0 auto' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>VIP Token Download</h1>
        <p style={{ textAlign: 'center' }}>Token ID: {id}</p>
        {tokenData ? (
          <div>
            <p>Token details will be displayed here</p>
          </div>
        ) : (
          <p style={{ textAlign: 'center', color: '#dc3545' }}>Token not found</p>
        )}
      </div>
    </div>
  );
};

export default DownloadToken;
